import { render, staticRenderFns } from "./leaf.vue?vue&type=template&id=6bda5226"
import script from "./leaf.vue?vue&type=script&lang=ts"
export * from "./leaf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports